// extracted by mini-css-extract-plugin
export var deleteIcon = "_mg-5";
export var deleteOption = "_mg-3";
export var divider = "_mg-2";
export var downloadIcon = "_mg-4";
export var drawer = "_mg-0";
export var drawerFooter = "_mg-6";
export var drawerOpen = "_mg-1";
export var highlighted = "_mg-7";
export var lighterHighlight = "_mg-8";